import { Country, Currency, Gender } from "@finbackoffice/enums";
import { TransactionMethodType, CasinoGameTypeEnum, AllCountries } from "@finbackoffice/fe-core";
import { TFunction } from "i18next";
import { DropdownOption } from "../types";

export const formatTransactionMethodId = (id: TransactionMethodType) =>
    id.replaceAll(".", "").toLowerCase();

export const formatCasinoProviderName = (text: string): string => {
    return text.replaceAll(" ", "-").toLowerCase();
};

export const getFildNameWithCurrency = (fieldName: string, currency: Currency) =>
    `${fieldName}_${currency.toLocaleLowerCase()}`;

export const splitArrIntoChunks = (arr: any[], chunkSize: number) => {
    const chunks = [];

    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        chunks.push(chunk);
    }
    return chunks;
};

export const isCasinoGameType = (val: CasinoGameTypeEnum) =>
    Object.values(CasinoGameTypeEnum).includes(val);

export const getAgeOptions = (): DropdownOption[] => {
    const result: DropdownOption[] = [];
    const min = 18;
    const max = 80;
    Array.from({ length: max - min + 1 }, (_, i) => i + min).forEach((age) => {
        result.push({ value: age.toString(), label: age.toString() });
    });

    return result;
};

export const getCountries = (supportedCountries: Country[]): DropdownOption[] => {
    const result: DropdownOption[] = [];

    for (let i = 0; i < supportedCountries.length; ++i) {
        const country = supportedCountries[i];
        result.push({
            value: country,
            label: AllCountries[country as Country],
        });
    }

    return result;
};

export const getGenders = (t: TFunction): DropdownOption[] => {
    const result: DropdownOption[] = [];
    Object.values(Gender).forEach((gender) => {
        result.push({
            value: gender,
            label: t(`userData_gender${gender}`),
        });
    });
    return result;
};

export const getCountryStates = (supportedCountrytates: { name: string }[]): DropdownOption[] => {
    const result: DropdownOption[] = [];

    for (const countryState of supportedCountrytates) {
        result.push({
            value: countryState.name,
            label: countryState.name,
        });
    }

    return result;
};

export const debounce = (func: (...args: any[]) => any, delay: number, immediate = false) => {
    let timeoutId: NodeJS.Timeout | null;
    return function executed(this: any, ...args: any[]) {
        const callNow = immediate && !timeoutId;

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            timeoutId = null;
            if (!immediate) func.apply(this, args);
        }, delay);

        if (callNow) func.apply(this, args);
    };
};

export function getRandomArbitrary(min: number, max: number) {
    return Math.floor(Math.random() * (max - min) + min);
}
